import styled from 'styled-components';

export const UnitTypesWrapper = styled.div`
  margin-bottom: 8px;
`;

export const BedroomTabNav = styled.nav`
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e0e0e0;
`;

export const BedroomTabItem = styled.button<{ active: boolean }>`
  background: none;
  border: none;
  padding: 0 0 8px 0;
  font-size: 16px;
  font-weight: ${({ active }) => (active ? '500' : '400')};
  color: ${({ active }) => (active ? '#0d1011' : '#737d87')};
  border-bottom: ${({ active }) =>
    active ? '3px solid #2b6ed2' : '3px solid transparent'};
  margin-bottom: -1px;
  cursor: pointer;
  white-space: nowrap;
`;

export const UnitTypeContainer = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 991px) {
    flex-direction: column;
  }
`;

/* ---- Left panel: unit selector ---- */

export const UnitSelectorDesktop = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 250px;
  flex-shrink: 0;
  overflow-y: auto;
  max-height: 400px;

  @media (max-width: 991px) {
    display: none;
  }
`;

export const UnitSelectorButton = styled.button<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 20px;
  border-radius: 16px;
  border: 1px solid ${({ active }) => (active ? 'transparent' : '#e0e0e0')};
  background-color: ${({ active }) => (active ? '#0d1011' : '#ffffff')};
  color: ${({ active }) => (active ? '#ffffff' : '#0d1011')};
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s ease;
  filter: drop-shadow(0 2px 4px rgba(var(--shadow-color), 0.08));
  box-shadow:
    0px 0px 2px 0px #fff6 inset,
    0px 2px 4px 0px #282c2e1f;
  &:hover {
    background-color: ${({ active }) => (active ? '#0d1011' : '#f5f5f5')};
  }
`;

export const UnitButtonName = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin: 0;
`;

export const UnitButtonSize = styled.p`
  font-size: 12px;
  font-weight: 300;
  margin: 0;
  opacity: 1;
`;

/* Mobile swiper unit selector */
export const UnitSelectorMobile = styled.div`
  display: none;
  margin-bottom: 16px;
  max-width: 100%;

  @media (max-width: 991px) {
    display: block;
  }
`;

export const MobileUnitScroller = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: none;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const MobileUnitItem = styled.button<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid ${({ active }) => (active ? '#0d1011' : '#e0e0e0')};
  background-color: ${({ active }) => (active ? '#0d1011' : '#ffffff')};
  color: ${({ active }) => (active ? '#ffffff' : '#0d1011')};
  filter: drop-shadow(0 2px 4px rgba(var(--shadow-color), 0.08));
  box-shadow:
    0px 0px 2px 0px #fff6 inset,
    0px 2px 4px 0px #282c2e1f;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
`;

/* ---- Right panel: unit detail ---- */

export const UnitDetailPanel = styled.div`
  flex: 1;
  min-width: 0;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const PriceLabel = styled.span`
  font-size: 20px;
  font-weight: 500;
  color: #0d1011;
`;

export const NoPriceLabel = styled.span`
  font-size: 14px;
  font-weight: 300;
  color: #5a6067;
`;

export const PriceBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  background-color: #f0f0f0;
  font-size: 12px;
  font-weight: 400;
  color: #555555;
`;

export const RequestPriceButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 15px;
  border-radius: 20px;
  border: 1px solid #0d1011;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #0d1011;
  text-decoration: none;
  cursor: pointer;
  margin-bottom: 10px;
  box-shadow:
    0px 2px 2px 0px #fff6 inset,
    0px 2px 4px 0px #282c2e1f;

  &:hover {
    background: #ededed;
    text-decoration: none;
    color: #0d1011;
  }
`;

export const SpecRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`;

export const SpecItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #0d1011;
  font-weight: 300;
`;

export const FurnishingRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 16px;
`;

export const FurnishingLabel = styled.span`
  font-weight: 500;
  color: #0d1011;
`;

export const FurnishingValue = styled.span`
  color: #333333;
  font-weight: 300;
`;

export const FeaturesSection = styled.div`
  margin-bottom: 20px;
`;

export const FeaturesLabel = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #0d1011;
  margin-bottom: 8px;
`;

export const FeaturesList = styled.ul`
  list-style: disc;
  padding-left: 20px;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 24px;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const FeatureItem = styled.li`
  font-size: 16px;
  color: #0d1011;
  padding-bottom: 4px;
  font-weight: 300;
`;

/* ---- Floor plan ---- */

export const FloorPlanWrapper = styled.div`
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #737d87;
  position: relative;
  max-width: 100%;
`;

export const FloorPlanImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  cursor: pointer;
  max-width: 100%;
`;

export const FloorPlanExpandButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border: 1px solid #737d87;

  &:hover {
    background: #ededed;
  }
`;

export const FloorPlanExpandButtonFull = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 15px;
  border-radius: 20px;
  border: 1px solid #0d1011;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #0d1011;
  text-decoration: none;
  cursor: pointer;
  margin-bottom: 10px;
  box-shadow:
    0px 2px 2px 0px #fff6 inset,
    0px 2px 4px 0px #282c2e1f;

  &:hover {
    background: #ededed;
    text-decoration: none;
    color: #0d1011;
  }
`;

export const FloorPlanUnavailable = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 24px 32px 24px;
  background-color: #eff1f5;
  border: 1px solid #737d87;
  border-radius: 16px;
  text-align: center;
`;

export const FloorPlanUnavailableIcon = styled.div`
  font-size: 48px;
  color: #cccccc;
`;

export const FloorPlanUnavailableImage = styled.img`
  height: auto;
`;

export const FloorPlanUnavailableText = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #5a6067;
  margin: 0;
`;

export const RequestFloorPlanButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  border-radius: 20px;
  border: 1px solid #0d1011;
  background: #f0f1f5;
  font-size: 14px;
  font-weight: 500;
  color: #0d1011;
  text-decoration: none;
  cursor: pointer;
  box-shadow:
    0px 2px 2px 0px #fff6 inset,
    0px 2px 4px 0px #282c2e1f;

  &:hover {
    background: #ededed;
    text-decoration: none;
    color: #0d1011;
  }
`;

/* ---- Floor plan lightbox ---- */

export const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.92);
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

export const LightboxHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  color: #ffffff;
`;

export const LightboxTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const LightboxTitleText = styled.span`
  font-size: 15px;
  font-weight: 600;
`;

export const LightboxSubText = styled.span`
  font-size: 13px;
  opacity: 0.7;
`;

export const LightboxCloseButton = styled.button`
  background: none;
  border: none;
  color: #ffffff;
  font-size: 24px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const LightboxBody = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
`;

export const LightboxImage = styled.img`
  max-width: 90%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 8px;
`;

export const LightboxNavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #ffffff;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &.prev {
    left: 16px;
  }
  &.next {
    right: 16px;
  }
`;

export const LightboxCounter = styled.div`
  text-align: center;
  padding: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
`;

export const LastUpdatedText = styled.p`
  font-size: 10px;
  color: #777777;
  margin: 8px 0 0 0;
  font-weight: 300;
  text-align: right;
`;

export const MobileUnitName = styled.span`
  font-size: 13px;
  font-weight: 600;
`;

export const MobileUnitSize = styled.span`
  font-size: 11px;
`;
